/**
 * SEO/GEO-optimized image component.
 * - Serves modern WebP with JPEG fallback via <picture>
 * - Requires descriptive alt text (image SEO)
 * - Adds lazy loading + async decoding + explicit width/height (CLS 0)
 * - Injects ImageObject JSON-LD when `schema` prop is passed (for Google/Perplexity image search)
 */
export default function SeoImage({
  slug,
  alt,
  width = 526,
  height = 526,
  className = "",
  eager = false,
  caption,
  schema = false,
  testId,
}) {
  const base = `/images/${slug}`;
  const jsonLd = schema
    ? {
        "@context": "https://schema.org",
        "@type": "ImageObject",
        contentUrl: `${base}.jpg`,
        description: alt,
        caption: caption || alt,
        creditText: "Katia Falón Odontología",
        creator: { "@type": "Organization", name: "Katia Falón Odontología" },
        copyrightNotice: "© Katia Falón Odontología",
      }
    : null;
  return (
    <>
      <picture>
        <source srcSet={`${base}.webp`} type="image/webp" />
        <img
          src={`${base}.jpg`}
          alt={alt}
          width={width}
          height={height}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          fetchpriority={eager ? "high" : "auto"}
          className={className}
          data-testid={testId}
        />
      </picture>
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}
